
              import "_sentry-debug-id-injection-stub";
              import * as OriginalModule from "./src/js/script.js";
              export default OriginalModule.default;
              export * from "./src/js/script.js";